<template>
  <div class="page">
    <div class="info">
      <div class="activity">
        <div class="head-title">活动信息</div>
        <div v-if="detailItem.activityTitle">
          <div class="information" v-show="detailItem.activityType2 != '1'">
            <div class="left">
              <van-image
                fit="cover"
                class="img"
                :src="
                  detailItem.activityPicFileUrl
                    ? detailItem.activityPicFileUrl
                    : defaultImg
                "
                radius="5px"
              ></van-image>
            </div>
            <div class="right">
              <h2 v-text="detailItem.activityTitle"></h2>
              <div class="column" v-if="detailItem.activityType1">
                <span class="title">活动类型：</span>
                <span class="message" :class="`color1`">
                  <!-- 活动类型为2是培训 -->
                  {{
                    detailItem.activityType1 == "2"
                      ? `${
                          typeOneMap[detailItem.activityType1] +
                          "-" +
                          typeTwoMap[detailItem.activityType2]
                        }`
                      : `${typeOneMap[detailItem.activityType1]}`
                  }}
                </span>
              </div>
              <div
                class="column"
                v-if="
                  detailItem.activityPresenter &&
                  detailItem.activityType1 != '1'
                "
              >
                <span class="title">主讲人：</span>
                <span
                  class="message"
                  v-text="detailItem.activityPresenter"
                ></span>
              </div>
              <div class="column" v-if="detailItem.activityPresenterMail">
                <span class="title">电子邮箱：</span>
                <span
                  class="message"
                  v-text="detailItem.activityPresenterMail"
                ></span>
              </div>
              <div
                class="column"
                v-hide="
                  !detailItem.activityBegintimeStr ||
                  detailItem.activityType2 == '2'
                "
              >
                <span class="title">开始时间：</span>
                <span
                  class="message"
                  v-text="detailItem.activityBegintimeStr"
                ></span>
              </div>
              <div
                class="column"
                v-hide="
                  !detailItem.activityBegintimeStr ||
                  detailItem.activityType2 == '2'
                "
              >
                <span class="title">结束时间：</span>
                <span
                  class="message"
                  v-text="detailItem.activityEndtimeStr"
                ></span>
              </div>
              <div class="column" v-if="detailItem.openingHours">
                <span class="title">开放时间：</span>
                <span class="message" v-text="detailItem.openingHours"></span>
              </div>
              <div class="column" v-if="detailItem.remainderDays">
                <span class="title">剩余天数：</span>
                <span class="message" v-text="detailItem.remainderDays"></span>
              </div>
              <div class="column" v-if="detailItem.activityAddress">
                <span class="title">活动地点：</span>
                <span
                  class="message"
                  v-text="detailItem.activityAddress"
                ></span>
              </div>
              <div class="column" v-if="detailItem.activityComments">
                <span class="title">活动备注：</span>
                <span
                  class="message"
                  v-text="detailItem.activityComments"
                ></span>
              </div>
              <div class="column" v-if="detailItem.conferenceStr">
                <span class="title big">线上会议号：</span>
                <span class="message" v-text="detailItem.conferenceStr"></span>
              </div>
              <div class="column" v-if="detailItem.remainingNumber">
                <span class="title big">剩余可预约人数：</span>
                <span
                  class="message"
                  v-text="detailItem.remainingNumber"
                ></span>
              </div>
              <!-- 活动附件 -->
              <div
                v-if="detailItem.fileName"
                class="column"
                @click="handleOpenPdf(detailItem.fileId)"
              >
                <span class="title">活动附件：</span>
                <span class="message link" v-text="detailItem.fileName"></span>
              </div>
            </div>
          </div>
          <div
            class="wrap-item"
            v-show="
              detailItem.activityType1 == '2' && detailItem.activityType2 == '1'
            "
          >
            <!-- 左侧时间 -->
            <div class="new-left">
              <div class="left-day">
                <span class="month" v-text="detailItem.timeList[1]"></span>
                <span class="day">/</span>
                <span v-text="detailItem.timeList[2]" class="day"></span>
              </div>
              <div class="year" v-text="detailItem.timeList[0]"></div>
            </div>
            <!-- 右侧数据 -->
            <div class="new-right">
              <h2 v-text="detailItem.activityTitle"></h2>
              <!-- 标题 -->
              <div class="info">
                <!-- 开始时间 -->
                <div class="column">
                  <span class="ico"
                    ><van-icon name="clock-o" color="#1989fa"
                  /></span>
                  <span
                    class="message"
                    v-text="handleMomentTime(detailItem.activityBegintimeStr)"
                  ></span>
                </div>
                <div class="column">
                  <span class="title"
                    ><van-icon name="clock-o" color="#1989fa"
                  /></span>
                  <span
                    class="message"
                    v-text="handleMomentTime(detailItem.activityEndtimeStr)"
                  ></span>
                </div>
                <div class="column" v-if="detailItem.activityType1">
                  <span class="title"
                    ><van-icon name="apps-o" color="#1989fa"
                  /></span>
                  <span class="message" :class="`color1`">
                    <!-- 活动类型为2是培训 -->
                    {{
                      detailItem.activityType1 == "2"
                        ? `${
                            typeOneMap[detailItem.activityType1] +
                            "-" +
                            typeTwoMap[detailItem.activityType2]
                          }`
                        : `${typeOneMap[detailItem.activityType1]}`
                    }}
                  </span>
                </div>
                <div
                  class="column"
                  v-if="
                    detailItem.activityPresenter &&
                    detailItem.activityType1 != '1'
                  "
                >
                  <span class="title"
                    ><van-icon name="user-o" color="#1989fa"
                  /></span>
                  <span
                    class="message"
                    v-text="detailItem.activityPresenter"
                  ></span>
                </div>
                <div class="column" v-if="detailItem.activityPresenterMail">
                  <span class="title"
                    ><van-icon name="envelop-o" color="#1989fa"
                  /></span>
                  <span
                    class="message"
                    v-text="detailItem.activityPresenterMail"
                  ></span>
                </div>
                <!-- 活动地点 -->
                <div
                  v-if="detailItem.activityAddress"
                  class="column van-multi-ellipsis--l2"
                >
                  <span><van-icon name="location-o" color="#1989fa" /></span>
                  <span
                    class="message"
                    v-text="detailItem.activityAddress"
                  ></span>
                </div>

                <div class="column" v-if="detailItem.activityComments">
                  <span class="title"
                    ><van-icon name="description" color="#1989fa"
                  /></span>
                  <span
                    class="message"
                    v-text="detailItem.activityComments"
                  ></span>
                </div>

                <div class="column" v-if="detailItem.remainingNumber">
                  <span class="title"
                    ><van-icon name="contact" color="#1989fa"
                  /></span>
                  <span
                    class="message"
                    v-text="detailItem.remainingNumber"
                  ></span>
                </div>

                <div class="column" v-if="detailItem.conferenceStr">
                  <span class="title"
                    ><van-icon name="records" color="#1989fa"
                  /></span>
                  <span
                    class="message"
                    v-text="detailItem.conferenceStr"
                  ></span>
                </div>
                <!-- 活动附件 -->
                <div
                  v-if="detailItem.fileName"
                  class="column"
                  @click="handleOpenPdf(detailItem.fileId)"
                >
                  <span><van-icon name="coupon-o" color="#1989fa" /></span>
                  <span
                    class="message link"
                    v-text="detailItem.fileName"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <van-empty v-else description="暂无活动信息" />
      </div>
      <div class="activity border" v-if="detailItem.activityCodeFileUrl">
        <div class="head-title">会议号二维码</div>
        <div class="meetingImg">
          <van-image
            fit="cover"
            class="imgs"
            :src="detailItem.activityCodeFileUrl"
            radius="5px"
          ></van-image>
        </div>
      </div>
      <div class="activity border">
        <div class="head-title">活动详情</div>
        <div
          v-if="detailItem.activityDescInfo"
          v-html="detailItem.activityDescInfo"
        ></div>
        <van-empty v-else description="暂无活动详情" />
      </div>
    </div>
    <van-popup
      v-model="pdfShow"
      closeable
      position="bottom"
      :style="{ height: '100%' }"
    >
      <div id="pdf"></div>
    </van-popup>
  </div>
</template>
<script>
import Pdfh5 from "pdfh5";
import { mapActions, mapGetters } from "vuex";
import { getSelectList, fileIdToUrlGet } from "@/api/common";
import {
  activityInfoGet,
  activitySignStatus,
  activitySign,
} from "@/api/activity";
import {
  STATUS_CODE_OK,
  UIS_AUTH_URL,
  DICT_T_ACTIVITY_TYPE_ONE,
  DICT_T_ACTIVITY_TYPE_TWO,
} from "@/config";
import { SelectListToMap } from "@/utils";
export default {
  name: "ActivitySign",
  computed: {
    // 活动类型1
    typeOneMap() {
      return SelectListToMap(this.typeList);
    },
    // 活动类型2
    typeTwoMap() {
      return SelectListToMap(this.typeTwo);
    },
    ...mapGetters(["token", "openId"]),
  },
  data() {
    return {
      defaultImg: require("@/assets/images/peixun.jpg"),
      detailItem: {},
      typeList: [],
      typeTwo: [],
      pdfShow: false,
    };
  },
  async created() {
    if (!this.token) {
      this.handleLogin();
    } else {
      await this.handleActivityTypeListGet();
      await this.handleActivityTypeTwoList();
      this.handleActivityDetail();
    }
  },
  methods: {
    // 格式化时间
    handleMomentTime(time) {
      return this.$moment(time)
        .locale("zh-cn")
        .format("YYYY年MMMDo（ddd）ah:mm");
    },
    // 获取活动类型一词典
    async handleActivityTypeListGet() {
      let { data } = await getSelectList({
        dictTable: DICT_T_ACTIVITY_TYPE_ONE,
      });
      if (data.code === STATUS_CODE_OK) {
        this.typeList = data.data;
      }
    },
    // 获取活动类型2
    async handleActivityTypeTwoList() {
      let { data } = await getSelectList({
        dictTable: DICT_T_ACTIVITY_TYPE_TWO,
      });
      if (data.code === STATUS_CODE_OK) {
        this.typeTwo = data.data;
      }
    },
    // 登录
    handleLogin() {
      const that = this;
      that.setLogout();
      if (process.env.VUE_APP_IS_WXAUTH === "Y") {
        window.location.replace(
          `${UIS_AUTH_URL}&path=${window.encodeURIComponent(
            that.$route.fullPath
          )}&openId=${that.openId}`
        );
      } else {
        window.location.replace(
          `${UIS_AUTH_URL}&path=${window.encodeURIComponent(
            that.$route.fullPath
          )}`
        );
      }
    },
    // 签到
    async handleSign() {
      const { activityId } = this.$route.query;
      const { data } = await activitySign({
        activityId: activityId,
      });
      if (data.code === STATUS_CODE_OK) {
        let tips = "签到成功";
        if (data.data.signInStatus == "1") {
          tips = "签到成功";
        } else {
          tips = data.data.returnInfo;
        }
        try {
          await this.$dialog.alert({
            title: "提示",
            message: tips,
          });
        } catch (err) {
          console.log(err);
        }
      }
    },
    // 获取活动详情
    async handleActivityDetail() {
      const { data } = await activityInfoGet({
        activityId: this.$route.query.activityId,
      });
      if (data.code === STATUS_CODE_OK) {
        this.detailItem = data.data;
        this.detailItem.timeList = this.detailItem.activityBegintimeStr
          .split(" ")[0]
          .split("-");
        this.handleSignStatusGet();
      }
    },
    // 活动签到状态获取
    async handleSignStatusGet() {
      const { data } = await activitySignStatus({
        activityId: this.$route.query.activityId,
      });
      if (data.code === STATUS_CODE_OK) {
        if (data.data == "1") {
          // 未签到
          try {
            await this.$dialog.confirm({
              title: "提示",
              message: "确认需要签到吗？",
              confirmButtonText: "签到",
              cancelButtonText: "取消",
              confirmButtonColor: "#1989fa",
            });
            this.handleSign();
          } catch (err) {
            console.log(err);
          }
        } else {
          // 已签到
          await this.$dialog.alert({
            title: "提示",
            message: "已签到",
            confirmButtonText: "好的",
          });
        }
      }
    },
    //  打开附件pdf
    async handleOpenPdf(fileId) {
      const that = this;
      if (fileId) {
        const { data } = await fileIdToUrlGet({
          fileId: fileId,
        });
        if (data.code === STATUS_CODE_OK) {
          that.pdfShow = true;
          that.$nextTick(() => {
            that.pdfh5 = new Pdfh5("#pdf", {
              pdfurl: data.data.fileUrl,
            });
          });
        }
      }
    },
    ...mapActions(["setLogout"]),
  },
};
</script>

<style scoped lang="scss">
.page {
  background-color: #f7f8fa;
  .info {
    width: 100%;
    background: #fff;
    color: #969799;
    font-size: 12px;
    .activity {
      padding: 10px;
      .head-title {
        color: #333;
        font-size: 14px;
        border-left: 5px solid rgb(27, 105, 181);
        text-indent: 5px;
        margin-bottom: 10px;
      }
      .meetingImg {
        text-align: center;
        .imgs {
          width: 200px;
          height: 200px;
        }
      }
      .information {
        display: flex;
        justify-content: space-between;
        .left {
          width: 135px;
          height: 200px;
          flex: none;
          .img {
            width: 100%;
            height: 100%;
          }
        }
        .right {
          padding-left: 10px;
          flex: 1;
          h2 {
            font-size: 14px;
            font-weight: normal;
            margin: 10px 0;
            width: 200px;
            color: #333;
          }
          .column {
            margin-bottom: 5px;
            .title {
              display: inline-block;
              width: 70px;
            }
            .big {
              width: 105px;
            }
            .message {
              text-align: left;
              word-break: break-all;
              word-wrap: break-word;
              white-space: pre-wrap;
              &.color1 {
                color: #1989fa;
              }
              &.color2 {
                color: #07c160;
              }
              &.color3 {
                color: #ff976a;
              }
              &.color4 {
                color: #ee0a24;
              }
            }
          }
        }
      }
      .wrap-item {
        margin-bottom: 10px;
        background: #fff;
        display: flex;
        justify-content: space-between;
        .new-left {
          margin-top: 5px;
          text-align: center;
          border-right: 0.5px solid #e8f1f5;
          .left-day {
            width: 60px;
          }
          .month {
            font-weight: bolder;
            font-size: 22px;
          }
          .day {
            color: rgb(111, 111, 111);
            font-size: 12px;
          }
          .year {
            font-size: 12px;
            border-radius: 20px;
            text-align: center;
            width: 40px;
            height: 20px;
            background: #1282f4;
            color: #f7f8fa;
            line-height: 20px;
            margin: 5px auto;
          }
        }
        .new-right {
          flex: 1;
          padding-bottom: 10px;
          margin-left: 15px;
          h2 {
            font-size: 18px;
            font-weight: normal;
            margin: 10px 0;
            width: 240px;
          }
          .message {
            margin-left: 5px;
            word-break: break-all;
            word-wrap: break-word;
            white-space: pre-wrap;
          }
          .info {
            font-size: 12px;
            color: #969799;
            .column {
              padding-top: 5px;
            }
          }
        }

        &:last-child {
          margin-bottom: 0px;
        }
      }
      .foot-btn {
        margin-top: 10px;
        .btn {
          margin-right: 10px;
          width: 70px;
          border-radius: 5px;
        }
      }
    }
    .border {
      border-top: 1px solid #eee;
    }
  }
  .dialog-status {
    .status-btn-wrap {
      display: flex;
      border-top: 1px solid #eee;
      .btn {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 0;
        &.btn-sure {
          border-left: 1px solid #eee;
          color: #ee0a24;
        }
      }
    }
  }
}
</style>
